import Select from 'tether-select';

var initSelect = function () {

    if (document.querySelector('.wpcf7-select')) {
        Select.init({
            el: document.querySelector('.wpcf7-select')
        });
    }
    
}

export {
    initSelect
};